import React, { Component } from 'react';
import { connect } from 'react-redux';

import Dim from 'web/components/common/modal/common/Dim';
import { initModal, pushModal } from 'shared/actions/modal.action';
import CloseBtn from 'web/components/common/modal/common/CloseBtn';
import * as input from 'web/components/common/modal/common/input';

import { postUserPasswordRequest } from 'shared/actions/auth.action';

import Logo from 'web/components/common/modal/common/Logo';

@connect(
  (state, props) => ({
    auth: state.shared.auth,
    modal: state.shared.modal,
  }),
  {
    initModal,
    pushModal,

    postUserPasswordRequest,
  },
)
class PasswordChangeContainer extends Component {
  state = {
    prev: '',
    new: '',
    error: '',
  };

  submit = e => {
    if (e) e.preventDefault();
    this.props.postUserPasswordRequest(this.state.prev, this.state.new, res => {
      if (res.code === 6002) {
        this.setState({ error: res.message });
      }
      if (res.code === 200) {
        this.props.initModal();
      }
    });
  };

  handlePrev = e => {
    this.setState({ prev: e.target.value });
  };
  handleNew = e => {
    this.setState({ new: e.target.value });
  };

  render() {
    const handlePopup = this.props.popupHandler;

    return (
      <Dim>
        <div
          className="modal"
          style={{
            position: 'relative',
            width: '320px',
            padding: '120px 30px 30px',
            backgroundColor: '#fff',
            color: '#000',
            borderRadius: '10px',
            overflow: 'hidden',
            textAlign: 'center',
            fontSize: '14px',
            lineHeight: '1.4',
          }}
        >
          <Logo />
          <h3
            style={{
              position: 'absolute',
              top: 75,
              left: 0,
              fontSize: 18,
              fontWeight: 600,
              width: '100%',
              textAlign: 'center',
            }}
          >
            비밀번호 변경
          </h3>
          <input.Text
            type="password"
            name="prev"
            placeholder="현재 비밀번호"
            value={this.state.prev}
            onChange={this.handlePrev}
            error={this.state.error}
          />
          <input.Text
            type="password"
            name="prev"
            placeholder="변경할 비밀번호"
            value={this.state.new}
            onChange={this.handleNew}
          />
          <input.Button onClick={this.submit}>변경</input.Button>
          <CloseBtn
            onClick={handlePopup.close}
            style={{ position: 'absolute', top: 20, right: 20 }}
          />
        </div>
      </Dim>
    );
  }
}

export default PasswordChangeContainer;
